<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#627EEA"/>
<path d="M11.9997 4V9.91456L16.9987 12.1484L11.9997 4Z" fill="#C1CCF7"/>
<path d="M11.9997 4L7 12.1484L11.9997 9.91456V4Z" fill="white"/>
<path d="M11.9997 15.981V19.9999L17.0021 13.0791L11.9997 15.981Z" fill="#C1CCF7"/>
<path d="M11.9997 19.9999V15.9804L7 13.0791L11.9997 19.9999Z" fill="white"/>
<path d="M11.9997 15.0511L16.9987 12.1485L11.9997 9.91602V15.0511Z" fill="#8198EE"/>
<path d="M7 12.1485L11.9997 15.0511V9.91602L7 12.1485Z" fill="#C1CCF7"/>
</svg>
